import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class BookingRentalAgreementActionModel extends Model {
  @attr('boolean') reset!: boolean;
  @attr('boolean') markedAsSigned!: boolean;

  @belongsTo('booking', {
    async: false,
    inverse: 'bookingRentalAgreementAction',
  })
  booking!: ModelRegistry['booking'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'booking-rental-agreement-action': BookingRentalAgreementActionModel;
  }
}
